import React, { useState } from 'react';
import { PublicLayout } from '../components/PublicLayout';
import { Users } from 'lucide-react';

const tabs = ['Penaung & Presiden', 'Majlis Kerja Tertinggi', 'Pengerusi Wilayah', 'Biro RSS'];

const pastPresidents = [
  { name: 'YBhg. Datuk Hj. Mohd. Taha Ariffin', period: '1987 – 1989' },
  { name: 'Tuan Hj. Arpan Molana Bin Hj. Derin', period: '1989 – 1990' },
  { name: 'YBhg. Datuk Hj. Effendi Norwawi', period: '1990 – 1999' },
  { name: 'YBhg. Datuk Wan Ali Yubi', period: '2000 – 2012' },
  { name: 'Tuan Hj. Ubaidillah Hj. Abdul Latip', period: '2013 – 2016' },
  { name: 'Tuan Hj. Muhammad Haneef Ali', period: '2016 – Kini', current: true },
];

const mkt = [
  { position: 'Presiden', name: 'Tuan Haji Muhammad Haneef Ali', level: 'primary' },
  { position: 'Timbalan Presiden', name: "Dato' Haji Mohamad Yusnar Bin Haji Matalie", level: 'primary' },
  { position: 'Naib Presiden I', name: 'Haji Mohamed Alli Bin Haji Zainudin', level: 'secondary' },
  { position: 'Naib Presiden II', name: 'Ismawi Bin Kedri', level: 'secondary' },
  { position: 'Setiausaha Agung', name: 'Abbas Hamzah Bin Muhd Haneef', level: 'secondary' },
  { position: 'Timbalan Setiausaha Agung', name: 'Mohd Azfar Bin Ismail', level: 'secondary' },
  { position: 'Bendahari Kehormat', name: 'Abdullah Bin Sulaiman', level: 'secondary' },
  { position: 'Penolong Bendahari', name: 'Akmal Zami bin Jaya@Mahdi', level: 'secondary' },
  { position: 'Ketua Penerangan', name: 'Mohd Rushairy bin Abu Bakar', level: 'secondary' },
  { position: 'Penasihat Undang-Undang', name: 'Addy Termizi Bin Mohammed Tuah', level: 'secondary' },
];

const wilayahChairs = [
  { no: 1, wilayah: 'Kuching', pengerusi: 'Abdul Taib Bin Yusup' },
  { no: 2, wilayah: 'Kota Samarahan', pengerusi: 'Haji Issnu Bin Dollah' },
  { no: 3, wilayah: 'Serian', pengerusi: 'Mohamed Tuah Bin Wasli' },
  { no: 4, wilayah: 'Sri Aman', pengerusi: 'Abdul Wahab Bin Abdul Wahid' },
  { no: 5, wilayah: 'Betong', pengerusi: 'Mohd Kahlik Bin Jerni' },
  { no: 6, wilayah: 'Sarikei', pengerusi: 'Dayangku Siti Mariam Bt Awg Masli' },
  { no: 7, wilayah: 'Sibu', pengerusi: 'Mohamad Razalee bin Hassan' },
  { no: 8, wilayah: 'Mukah', pengerusi: 'Jamal Bin Wasli' },
  { no: 9, wilayah: 'Kapit', pengerusi: 'Awg. Rosman bin Awg. Japar' },
  { no: 10, wilayah: 'Bintulu', pengerusi: 'Rushdy bin Rosli' },
  { no: 11, wilayah: 'Miri', pengerusi: 'Haji Madon Bin Sulong' },
  { no: 12, wilayah: 'Limbang', pengerusi: 'Haji Razduan Bin Ibrahim' },
  { no: 13, wilayah: 'Lawas', pengerusi: 'Mohamad Noor bin Ahmat' },
];

const biroData = [
  {
    name: 'Biro Kejurulatihan',
    penasihat: null,
    ketua: 'Encik Hussien Bin Zawawi',
    desc: 'Bertanggungjawab ke atas pembangunan program latihan, pensijilan jurulatih dan pengembangan kemahiran silat di seluruh Sarawak.',
    color: '#D71920',
  },
  {
    name: 'Biro Teknikal',
    penasihat: 'Tuan Haji Mohamed Alli Bin Haji Zainudin',
    ketua: 'Encik Awang Pathi Bin Awang Daud',
    desc: 'Mengurus hal teknikal pertandingan, penilaian kemahiran, wasit-juri dan penyeragaman peraturan silat peringkat negeri.',
    color: '#D4AF37',
  },
  {
    name: 'Biro Perhubungan Antarabangsa',
    penasihat: null,
    ketua: "Dato' Haji Mohamad Yusnar Bin Haji Matalie",
    desc: 'Menguruskan hubungan dengan badan silat antarabangsa, penyertaan dalam kejuaraan dunia dan perwakilan Malaysia.',
    color: '#0B0B0B',
  },
];

const InitialAvatar = ({ name, size = 'md' }) => {
  const initials = name
    .replace(/^(YAB|YBhg\.|Tuan|Haji|Dato'|Datuk|Hj\.|Bin|Bt|Awg\.)\s/gi, '')
    .split(' ')
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase();

  const sizes = {
    sm: 'w-10 h-10 text-xs',
    md: 'w-14 h-14 text-sm',
    lg: 'w-20 h-20 text-base',
    xl: 'w-24 h-24 text-xl',
  };

  return (
    <div className={`${sizes[size]} rounded-full bg-[#D71920]/10 border-2 border-[#D71920]/20 flex items-center justify-center font-bold text-[#D71920] flex-shrink-0`}>
      {initials || <Users size={16} />}
    </div>
  );
};

export default function Kepimpinan() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <PublicLayout>
      {/* Page Header */}
      <div className="bg-[#0B0B0B] text-white py-16">
        <div className="h-0.5 bg-gradient-to-r from-[#D71920] via-[#FFD21F] to-[#D71920] -mt-16 mb-16" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <p className="text-xs text-[#FFD21F] font-bold tracking-widest uppercase mb-3">Utama / Kepimpinan</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight" data-testid="kepimpinan-title">
            Kepimpinan Rumpun Silat Sarawak
          </h1>
          <p className="text-[#999] mt-3 text-sm sm:text-base max-w-2xl">
            Barisan kepimpinan yang mentadbir dan membangunkan Rumpun Silat Sarawak.
          </p>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white border-b border-[#E5E5E5] sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex gap-0 overflow-x-auto">
            {tabs.map((tab, i) => (
              <button
                key={i}
                onClick={() => setActiveTab(i)}
                className={`px-4 py-4 text-xs sm:text-sm font-semibold whitespace-nowrap border-b-2 transition-colors ${
                  activeTab === i
                    ? 'border-[#D71920] text-[#D71920]'
                    : 'border-transparent text-[#555] hover:text-[#0B0B0B]'
                }`}
                data-testid={`tab-${i}`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="min-h-screen">

        {/* Tab 0: Penaung & Presiden */}
        {activeTab === 0 && (
          <div>
            {/* Penaung */}
            <section className="bg-white py-14">
              <div className="max-w-7xl mx-auto px-4 sm:px-6">
                <div className="text-xs font-bold tracking-widest text-[#D71920] uppercase mb-5">Penaung</div>
                <div className="bg-[#0B0B0B] rounded overflow-hidden">
                  <div className="h-1 bg-gradient-to-r from-[#D71920] via-[#FFD21F] to-[#D71920]" />
                  <div className="p-8 sm:p-10">
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
                      <div className="w-20 h-20 rounded-full bg-[#FFD21F]/10 border-2 border-[#FFD21F]/30 flex items-center justify-center flex-shrink-0">
                        <Users size={32} className="text-[#FFD21F]" />
                      </div>
                      <div>
                        <div className="text-xs font-bold tracking-widest text-[#FFD21F] uppercase mb-2">Penaung RSS Sarawak</div>
                        <h2 className="text-xl sm:text-2xl font-extrabold text-white leading-tight">
                          Yang Amat Berhormat Datuk Patinggi
                        </h2>
                        <h2 className="text-xl sm:text-2xl font-extrabold text-[#FFD21F] leading-tight mt-0.5">
                          Tan Sri (Dr) Abang Haji Abdul Rahman Zohari
                        </h2>
                        <h2 className="text-lg sm:text-xl font-bold text-white/80 leading-tight mt-0.5">
                          Bin Tun Datuk Abang Haji Openg
                        </h2>
                        <div className="mt-3 text-sm text-[#999]">Premier Sarawak</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Barisan Presiden */}
            <section className="bg-[#F7F7F7] py-14">
              <div className="max-w-7xl mx-auto px-4 sm:px-6">
                <div className="text-xs font-bold tracking-widest text-[#D71920] uppercase mb-3">Sejarah Kepimpinan</div>
                <h2 className="text-2xl font-extrabold text-[#0B0B0B] mb-8">Barisan Presiden RSS</h2>
                <div className="space-y-2">
                  {pastPresidents.map((p, i) => (
                    <div
                      key={i}
                      className={`flex items-center gap-4 p-4 rounded border transition-colors ${
                        p.current
                          ? 'bg-white border-[#D71920]/30 shadow-sm'
                          : 'bg-white border-[#E5E5E5]'
                      }`}
                      data-testid={`president-${i}`}
                    >
                      <div
                        className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-extrabold flex-shrink-0 ${
                          p.current ? 'bg-[#D71920] text-white' : 'bg-[#F7F7F7] text-[#999] border border-[#E5E5E5]'
                        }`}
                      >
                        {i + 1}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className={`font-bold text-sm leading-tight ${p.current ? 'text-[#D71920]' : 'text-[#0B0B0B]'}`}>
                          {p.name}
                        </div>
                      </div>
                      <div className="flex items-center gap-2 flex-shrink-0">
                        <span className="text-xs text-[#777] font-medium">{p.period}</span>
                        {p.current && (
                          <span className="text-[10px] font-bold bg-[#D71920] text-white px-2 py-0.5 rounded-full">
                            KINI
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </div>
        )}

        {/* Tab 1: Majlis Kerja Tertinggi */}
        {activeTab === 1 && (
          <section className="bg-white py-14">
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
              <div className="text-xs font-bold tracking-widest text-[#D71920] uppercase mb-3">Pentadbiran Pusat</div>
              <h2 className="text-2xl font-extrabold text-[#0B0B0B] mb-8">Ahli Majlis Kerja Tertinggi</h2>
              <div className="grid sm:grid-cols-2 gap-4">
                {mkt.map((m, i) => (
                  <div
                    key={i}
                    className={`flex items-center gap-4 p-5 rounded border transition-all hover:shadow-sm ${
                      m.level === 'primary'
                        ? 'border-[#D71920]/30 bg-[#FEF2F2]/30'
                        : 'border-[#E5E5E5] bg-white'
                    }`}
                    data-testid={`mkt-card-${i}`}
                  >
                    <InitialAvatar name={m.name} size={m.level === 'primary' ? 'lg' : 'md'} />
                    <div className="min-w-0">
                      <div className={`text-[10px] font-bold uppercase tracking-wider mb-1 ${
                        m.level === 'primary' ? 'text-[#D71920]' : 'text-[#999]'
                      }`}>
                        {m.position}
                      </div>
                      <div className="font-bold text-[#0B0B0B] text-sm leading-tight">{m.name}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Tab 2: Pengerusi Wilayah */}
        {activeTab === 2 && (
          <section className="bg-white py-14">
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
              <div className="text-xs font-bold tracking-widest text-[#D71920] uppercase mb-3">13 Wilayah RSS</div>
              <h2 className="text-2xl font-extrabold text-[#0B0B0B] mb-8">Pengerusi RSS Wilayah</h2>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {wilayahChairs.map((w, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-4 p-5 border border-[#E5E5E5] rounded hover:border-[#D71920]/30 hover:shadow-sm transition-all bg-white"
                    data-testid={`wilayah-chair-${i}`}
                  >
                    <div className="w-10 h-10 rounded-full bg-[#D71920]/8 border border-[#D71920]/20 flex items-center justify-center font-bold text-[#D71920] text-sm flex-shrink-0">
                      {String(w.no).padStart(2, '0')}
                    </div>
                    <div className="min-w-0">
                      <div className="text-[10px] font-bold text-[#D71920] uppercase tracking-wider">
                        RSS Wilayah {w.wilayah}
                      </div>
                      <div className="text-xs font-semibold text-[#0B0B0B] mt-0.5 leading-tight truncate" title={w.pengerusi}>
                        {w.pengerusi}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Tab 3: Biro RSS */}
        {activeTab === 3 && (
          <section className="bg-white py-14">
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
              <div className="text-xs font-bold tracking-widest text-[#D71920] uppercase mb-3">Bahagian Teknikal</div>
              <h2 className="text-2xl font-extrabold text-[#0B0B0B] mb-8">Biro Rumpun Silat Sarawak</h2>
              <div className="grid sm:grid-cols-3 gap-6">
                {biroData.map((b, i) => (
                  <div
                    key={i}
                    className="border border-[#E5E5E5] rounded overflow-hidden hover:shadow-md transition-shadow"
                    style={{ borderTopColor: b.color, borderTopWidth: 3 }}
                    data-testid={`biro-card-${i}`}
                  >
                    <div className="p-6">
                      <h3 className="font-extrabold text-[#0B0B0B] text-base mb-3">{b.name}</h3>
                      <p className="text-xs text-[#777] leading-relaxed mb-5">{b.desc}</p>
                      {b.penasihat && (
                        <div className="mb-3">
                          <div className="text-[10px] font-bold text-[#999] uppercase tracking-wide mb-0.5">Penasihat</div>
                          <div className="text-xs font-semibold text-[#0B0B0B]">{b.penasihat}</div>
                        </div>
                      )}
                      <div>
                        <div className="text-[10px] font-bold text-[#999] uppercase tracking-wide mb-0.5">Ketua Penyelaras</div>
                        <div className="text-xs font-semibold text-[#0B0B0B]">{b.ketua}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}
      </div>
    </PublicLayout>
  );
}
